import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const PracticeName = () => {
  let stateRedux = useSelector(state => state)
  let PracticeName = useSelector(state => state.GeneralDropDownsReducer?.Practice?.[0]?.PracticeName);
  console.log("stateRedux", stateRedux, PracticeName)
  useEffect(() => {
    if (stateRedux.SidebarActiveTab === 11) {
      document.getElementById('root')?.classList.add('dashboard_tooltip'); // Adds the class
    } else {
      document.getElementById('root')?.classList.remove('dashboard_tooltip'); // Adds the class
    }
    if (stateRedux.SidebarActiveTab === 14) {
      document.getElementById('root')?.classList.add('BillingItems_tooltip'); // Adds the class
    } else {
      document.getElementById('root')?.classList.remove('BillingItems_tooltip'); // Adds the class
    }
  }, [stateRedux.SidebarActiveTab])

  return (
    <div className="d-flex align-items-center gap-2">
      <button className="btn-header-toggle"><i className="bi bi-list"></i></button>
      {PracticeName ? (
        <p className="heading top_heading">{PracticeName}</p>
      ) : (
        null
      )}
    </div>
  )
}

export default PracticeName